module.exports = __webpack_public_path__ + "static/media/pricing-checkbox.0165a732.svg";